module.exports = __webpack_public_path__ + "img/bcc.92f797f3.svg";